module.exports = __webpack_public_path__ + "img/logo.59dce8fc.png";